import React, { Fragment, useState } from 'react';
import { post } from '../../../../Services/http';
import { translate } from '../../../../Services/translation';
import { SubscriptionPausedStatus } from '../../../../constants';

const PauseOrCancelSubscriptionPopUp = (props) => {
    const [generalErrors, setgeneralErrors] = useState([]);

    const cancelSubscription = () => {
        post(`/api/customer/pauseorcancelsubscription/${props.customerId}/${true}`)
            .then(() => {
                props.hidePopUp();
                props.refresh();
            });
    }

    const pauseSubscription = () => {
        post(`/api/customer/pauseorcancelsubscription/${props.customerId}`)
            .then(() => {
                props.hidePopUp();
                props.refresh();
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    setgeneralErrors([translate('coptikk.adminportal.subscription.generalerror')]);
                    setTimeout(() => {
                        props.hidePopUp();
                    }, 1000);
                }
            });
    }

    return (<Fragment>
        <div className='subscription__popup-container'>
            <div className='subscription__popup-content'>
                {generalErrors && generalErrors.length > 0 && generalErrors.map(errorItem => {
                    return <div className='error'>{errorItem}</div>
                })}
                { props.subscriptionStatus === SubscriptionPausedStatus ? (
                    <div>
                        <div className='add-to-cart-pop-up__close' onClick={() => props.hidePopUp()}></div>
                        <div className='top-row'>
                            <h2 className='title'>{translate("coptikk.adminportal.subscription.cancel")}</h2>
                        </div>                        
                        <a className='cancel-button' onClick={() => cancelSubscription()}>{translate("coptikk.adminportal.subscription.cancel")}</a>
                    </div>
                ) : (
                    <div>
                        <div className='add-to-cart-pop-up__close' onClick={() => props.hidePopUp()}></div>
                        <div className='top-row'>
                            <h2 className='title'>{translate("coptikk.adminportal.subscription.pauseorstoptext")}</h2>
                        </div>                        
                        <a className='pause-button' onClick={() => pauseSubscription()}>{translate("coptikk.adminportal.subscription.pausenext")}</a>
                        <p className='text'>{translate("coptikk.adminportal.subscription.ortext")}</p>
                        <a className='cancel-button' onClick={() => cancelSubscription()}>{translate("coptikk.adminportal.subscription.cancel")}</a>
                    </div>
                )}
            </div>
        </div>
    </Fragment>)
}

export default PauseOrCancelSubscriptionPopUp;